import { createApp } from 'vue'
import App from './App.vue'
import "@/assets/css/app.css"

createApp(App).mount('#app');